/**
 * @generated SignedSource<<f66aaaf1eb9fcf0a4992050ddae48228>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type checkoutSetUpActions_transaction$data = {
  readonly isPreAuthNegotiation: boolean | null;
  readonly isPrivateOffer: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"checkoutTrackingActions_transaction" | "checkoutUIActionsTransactionSetup_transaction">;
  readonly " $fragmentType": "checkoutSetUpActions_transaction";
};
export type checkoutSetUpActions_transaction$key = {
  readonly " $data"?: checkoutSetUpActions_transaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"checkoutSetUpActions_transaction">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "checkoutSetUpActions_transaction"
};

(node as any).hash = "f9a947fea026e85acd53534b3f392c7f";

export default node;
